// extracted by mini-css-extract-plugin
export var border = "_l-7";
export var brand = "_l-s";
export var button = "_l-k";
export var center = "_l-9";
export var centered = "_l-5";
export var closeButton = "_l-b";
export var disabledWrapper = "_l-l";
export var error = "_l-o";
export var extraLarge = "_l-4";
export var extraSmall = "_l-1";
export var fill = "_l-h";
export var footer = "_l-g";
export var footerAction = "_l-i";
export var footerButtons = "_l-j";
export var header = "_l-6";
export var headerWithClose = "_l-c";
export var icon = "_l-n";
export var info = "_l-r";
export var inline = "_l-8";
export var large = "_l-3";
export var main = "_l-d";
export var modal = "_l-0";
export var neutral = "_l-t";
export var noPadding = "_l-f";
export var none = "_l-u";
export var scrollable = "_l-e";
export var small = "_l-2";
export var success = "_l-q";
export var tight = "_l-m";
export var titleIcon = "_l-a";
export var warn = "_l-p";